import React from "react";
import withStyles from "isomorphic-style-loader/lib/withStyles";
import { Button } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faExclamationTriangle,
  faInfoCircle
} from "@fortawesome/free-solid-svg-icons";
import ModalFrame from "../../../../toolkit/modalFrame";
import AnualidadSnapshot from "../../../../types/AnualidadSnapshot";
import { detectarCambiosAnualidad } from "../../../../utils/anualidadSnapshotChanges";
import s from "./styles.scss";

interface Props {
  isOpen: boolean;
  snapshot: AnualidadSnapshot;
  onClose: () => void;
}

const MostrarCambiosModal = ({ isOpen, snapshot, onClose }: Props) => {
  if (!snapshot) {
    return null;
  }

  const cambios = detectarCambiosAnualidad(snapshot);
  const hayCambios = cambios.length > 0;

  const renderCambio = (cambio, index) => {
    const esCambioPrecio = cambio.campo === "cambioPrecio";
    const esEvaluador = cambio.campo === "evaluador";
    const esEliminada = cambio.campo === "eliminada";

    let alertClass = "alert-info";
    let icon = faInfoCircle;

    if (esCambioPrecio || esEliminada) {
      alertClass = "alert-warning";
      icon = faExclamationTriangle;
    } else if (esEvaluador) {
      alertClass = "alert-success";
    }

    return (
      <div key={index} className={`alert ${alertClass} mb-2`} role="alert">
        <FontAwesomeIcon icon={icon} className="mr-2" />
        {cambio.mensaje}
      </div>
    );
  };

  return (
    <ModalFrame
      title="Detalles de Cambios - Anualidad"
      isOpen={isOpen}
      toggle={onClose}
      size="lg"
    >
      <div className="mb-3">
        <p className="text-muted">
          <strong>Cotización:</strong> {snapshot.idCotizacionItem} |
          <strong> Periodo:</strong> {snapshot.periodo} |
          <strong> Folio:</strong> {snapshot.folioFactura || "N/A"}
        </p>
        {snapshot.vendedor && (
          <p className="text-muted">
            <strong>Vendedor:</strong> {snapshot.vendedor}
          </p>
        )}
      </div>

      {!hayCambios ? (
        <div className="alert alert-info">
          <FontAwesomeIcon icon={faInfoCircle} className="mr-2" />
          No se detectaron cambios en esta anualidad
        </div>
      ) : (
        <>
          <p className="mb-3">
            Se detectaron <strong>{cambios.length}</strong> cambio
            {cambios.length !== 1 ? "s" : ""}:
          </p>
          <div className="mb-3">
            {cambios.map((cambio, index) => renderCambio(cambio, index))}
          </div>
        </>
      )}

      {snapshot.observaciones && (
        <div className="mt-3">
          <p className="mb-1">
            <strong>Observaciones del evaluador:</strong>
          </p>
          <div className="alert alert-secondary">{snapshot.observaciones}</div>
        </div>
      )}

      <div className="text-right mt-3">
        <Button color="primary" onClick={onClose}>
          Cerrar
        </Button>
      </div>
    </ModalFrame>
  );
};

export default withStyles(s)(MostrarCambiosModal);
